import {
  Group,
  GroupOutlined,
  GroupTwoTone,
  Groups,
  GroupsOutlined,
  Person,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import React from 'react';

import { Roles } from '~/data/user';
import {
  WorkspaceUserGroup,
  getWorkspaceUserGroup,
} from '~/scenes/MyWorkspace/data';

type PropsType = SvgIconProps & {
  type: Roles | string;
};

export const WorkspaceRoleIcon = (
  props: PropsType,
): React.ReactElement | null => {
  const { type, ...rest } = props;

  const iconProps: SvgIconProps = {
    fontSize: 'medium',
    ...rest,
  };

  switch (getWorkspaceUserGroup(type)) {
    case WorkspaceUserGroup.Manager:
      return <Group {...iconProps} />;
    case WorkspaceUserGroup.DeputyManager:
      return <GroupOutlined {...iconProps} />;
    case WorkspaceUserGroup.AlternateManager:
      return <GroupTwoTone {...iconProps} />;
    case WorkspaceUserGroup.HrStaff:
      return <GroupsOutlined {...iconProps} />;
    case WorkspaceUserGroup.HrAdmin:
      return <Groups {...iconProps} />;
    default:
      return <Person {...iconProps} />;
  }
};
